import { Box3, Vector2, Vector3 } from 'three';
import { WINDOW_BACKGROUND_COLOR, WINDOW_BORDER_COLOR, WINDOW_SPACER_COLOR } from '../styleConfig';
import { ResourcesManager, ViewerModule, WindowComponent } from '@verybigthings/vbt-webvr-framework';
export class FuturisticWindow extends ViewerModule {
    constructor(options) {
        super();
        this.options = options;
        this.options.radius = this.options.radius || 0.1;
        this.resourcesInUse = [];
    }
    init() {
        if (this.options.type === 1) {
            this.addObject(this.background1 = new WindowComponent({
                size: this.options.size,
                bordColor: WINDOW_BORDER_COLOR.getHex(),
                background: WINDOW_SPACER_COLOR.getHex(),
                bordWidth: this.options.borderWidth || 0.05,
                bordRadius: this.options.radius
            }));
            if (this.options.hasSideImage) {
                // this.addObject(this.sideImage =
                //     new Mesh(
                //         new PlaneGeometry(2.5, 2.5),
                //         new MeshBasicMaterial({map: ResourcesManager.getTexture('popup_decoration'), transparent: true})));
                this.background1.uiObject.children[0].material.map = ResourcesManager.getTexture('popup_decoration');
            }
        }
        else if (this.options.type === 2) {
            this.addObject(this.background1 = new WindowComponent({
                size: this.options.size,
                bordColor: WINDOW_BORDER_COLOR.getHex(),
                background: WINDOW_SPACER_COLOR.getHex(),
                bordWidth: this.options.borderWidth || 0.05,
                bordRadius: this.options.radius
            }));
            this.background1.uiObject.position.z -= 0.01;
            this.addObject(this.background2 = new WindowComponent({
                size: new Vector2(this.options.size.x - 0.2, this.options.size.y - 0.2),
                background: WINDOW_BACKGROUND_COLOR.getHex(),
                bordWidth: 0.0,
                bordRadius: this.options.radius
            }));
        }
        else if (this.options.type === 3) {
            this.addObject(this.background1 = new WindowComponent({
                size: this.options.size,
                bordColor: WINDOW_BORDER_COLOR.getHex(),
                background: WINDOW_SPACER_COLOR.getHex(),
                bordWidth: this.options.borderWidth || 0.05,
                bordRadius: this.options.radius
            }));
            if (this.options.hasSideImage) {
                // this.addObject(this.sideImage =
                //     new Mesh(
                //         new PlaneGeometry(2.5, 2.5),
                //         new MeshBasicMaterial({map: ResourcesManager.getTexture('popup_decoration'), transparent: true})));
                this.background1.uiObject.children[0].material.map = ResourcesManager.getTexture('popup_decoration_short');
            }
        }
        // if (this.options.hasSideImage) {
        //     this.addObject(this.sideImage =
        //         new Mesh(
        //             new PlaneGeometry(2.5, 2.5),
        //             new MeshBasicMaterial({map: ResourcesManager.getTexture('popup_decoration'), transparent: true})));
        //     this.sideImage.position.set(this.options.size.x / 2 - 1.6, -this.options.size.y / 2 + 1.6, 0.02);
        //
        // }
    }
    setObject(object) {
        const box = new Box3();
        box.setFromObject(object);
        const size = new Vector3();
        box.getSize(size);
        if (this.currentObject && this.currentObject.parent)
            this.currentObject.parent.remove(this.currentObject);
        this.uiObject.add(object);
        this.currentObject = object;
        this.options.size.set(size.x, size.y);
        this.background1 && this.disposeObject(this.background1);
        this.background2 && this.disposeObject(this.background2);
        this.init();
    }
    minimize(time) {
    }
    maximize(time) {
    }
}
